import {action, makeAutoObservable} from "mobx"
import React from "react"
import {DestinationComponent} from "../../components/destination/DestinationComponent"
import Attribute from "./Attribute"
import {GroupBase} from "react-select"
import ProductRulesApi from "../../api/ProductRulesApi"
import AttributesApi from "../../api/AttributesApi"
import {AdapterOption} from "../../components/AsyncAdapterSelection"
import {UnitSelection} from "../../components/UnitSelection"

const fixedValueAdapter = "ozonFixedValueAdapter"

export default class valueOutput {
    private _attribute: Attribute | undefined
    private _is_required: boolean | undefined
    private readonly _isShowUnits: boolean = true

    constructor(destination: RuleObj, attribute?: Attribute, isShowUnits = true) {
        this.initializeDestination(destination, attribute)
        if (!isShowUnits) {
            this._isShowUnits = false
        }
        makeAutoObservable(this)
    }

    private _unitsOptions: { label: string, value: string }[] | undefined

    get unitsOptions(): { label: string; value: string }[] | undefined {
        return this._unitsOptions
    }

    private _unitsDefaultOption: { label: string, value: string } | undefined

    get unitsDefaultOption(): { label: string; value: string } | undefined {
        return this._unitsDefaultOption
    }

    get isCompared(): boolean {
        return !this._defaultOption
    }

    private _defaultOptions: false | AdapterOption[] | GroupBase<AdapterOption>[] = false

    get defaultOptions(): any {
        return this._defaultOptions
    }

    set defaultOptions(value: any) {
        this._defaultOptions = value
    }

    private _defaultOption: AdapterOption | undefined

    get defaultOption(): AdapterOption | undefined {
        return this._defaultOption
    }

    private _ozon_attribute_id: number | undefined

    get ozon_attribute_id(): number | undefined {
        return this._ozon_attribute_id
    }

    private _category_id: number | undefined

    get category_id(): number | undefined {
        return this._category_id
    }

    private _output_data: string = ""

    get output_data(): string {
        return this._output_data
    }

    private _type: string = ""

    get type(): string {
        return this._type
    }

    private _label: string = ""

    get label(): string {
        return this._label
    }

    private _description: string | undefined

    get description(): string | undefined {
        return this._description
    }

    private _input_type: string | undefined

    get input_type(): string | undefined {
        return this._input_type
    }

    private _input_data: string | undefined

    get input_data(): string | undefined {
        return this._input_data
    }

    get isRequired(): boolean {
        if (this._attribute) {
            return this._attribute.isRequried
        } else {
            return !!this._is_required
        }
    }

    get hasValue() {
        return this._input_data && this._input_type
    }

    get additional() {
        let component = undefined
        if (this._unitsOptions && this._isShowUnits) {
            component = <div style={{minWidth: 120, marginRight: 4}}>
                <UnitSelection destination={this}/>
            </div>
        }
        if (this._attribute) {
            component = <div
                style={{display: "flex", alignItems: "center"}}>{component}{this._attribute.additionalComponents}</div>
        }
        return component
    }

    getComponent(index: number | string) {
        return <DestinationComponent destination={this} key={this.type + index}/>
    }

    setRuleAndSave(adapterType: string, value: string, label: string) {
        this._input_type = adapterType
        this._input_data = value
        this._output_data = label
        return this.sendDestination()
    }

    sendDestination() {
        if (!this._input_data || !this._input_type) {
            console.warn("Попытка сохранить не заполненные настройки")
            return
        }
        return ProductRulesApi.saveValueOutput({
            output_type: this._type,
            input_name: this._input_data,
            input_type: this._input_type,
            // output_data: this.output_data,
            ozon_attribute_id: this._ozon_attribute_id,
            ozon_category_id: this._category_id
        })
            // .then((value => this.initializeDestination(value.data.data, this._attribute)))
    }

    deleteDestination() {
        return ProductRulesApi.deleteRule({
            output_type: this._type,
            ozon_attribute_id: this._ozon_attribute_id,
            ozon_category_id: this._category_id
        }).then(action("deleteDestinationComplete", () => {
            this._input_data = undefined
            this._input_type = undefined
            this._unitsOptions = undefined
            this._unitsDefaultOption = undefined
            this._output_data = ""
        }))
    }


    saveUnit(value: string) {
        this._output_data = value
        this.sendDestination()
    }

    private initializeDestination(destination: RuleObj, attribute?: Attribute) {
        this._label = destination.label
        this._description = destination.description
        this._type = destination.type
        if (destination.rule) {
            const rule = destination.rule
            this._input_type = rule.input_type
            this._input_data = rule.input_data
            if (rule.output_data) {
                this._output_data = rule.output_data
            }
            if (rule.input_type === fixedValueAdapter && rule.output_data) {
                rule.rule_label = rule.output_data
            }
            this._defaultOption = {
                label: rule.rule_label,
                value: rule.input_data,
                adapterType: rule.input_type,
            }
            if (rule.units) {
                const unitsOptions = []
                for (const unit of rule.units) {
                    unitsOptions.push({label: unit.title, value: unit.value})
                    if (unit.value === this.output_data) {
                        this._unitsDefaultOption = {label: unit.title, value: unit.value}
                    }
                }
                this._unitsOptions = unitsOptions
            } else {
                this._unitsOptions = undefined
            }
        }
        this._ozon_attribute_id = destination.ozon_attribute_id
        this._category_id = destination.category_id
        this._attribute = attribute
        this._is_required = destination.is_required
    }


}

export interface RuleObj {
    name: string
    label: string
    description?: string
    rule?: ProductRule
    type: string,
    category_id?: number
    adapters_types: string[]
    is_required?: boolean
    ozon_attribute_id?: number
}

export interface ProductRule {
    ozon_category_id?: number
    output_type: string
    output_data: string
    id: number
    rule_label: string
    input_data: string
    input_type: string
    ozon_attribute_id?: number
    units?: {
        title: string
        value: string
    }[]
}